import {
    GET_REPORTING,
    GET_REPORTING_START,
    GET_REPORTING_DATA,
    GET_REPORTING_END,
} from '../slices/type';

interface InitState {
    data: any[]; 
    dataSingle: any[]; 
    loading: boolean;
}

const initState: InitState = {
    data: [],
    dataSingle: [],
    loading: false,
};

interface Action {
    type: string;
    payload?: any; 
    loading?: boolean;
}

const Reporting_Red = (state = initState, action: Action): InitState => {
    switch (action.type) {
        case GET_REPORTING_START:
            return {
                ...state,
                loading: action.loading ?? false, 
            };
        case GET_REPORTING_DATA:
            return {
                ...state,
                data: action.payload ?? [],
                loading: action.loading ?? false,
            };

        case GET_REPORTING_END:
            return {
                ...state,
                dataSingle: action.payload ?? [],
                loading: action.loading ?? false,
            };
        default:
            return state;
    }
};

export default Reporting_Red;
